<template>
  <button class="i_btn" :class="{disabled_btn: disabled, heat_beat: heatBeat}" :style="style" :disabled="disabled"
          @click="clickHandle">{{text}}
  </button>
</template>

<script>
const btnStyleMap = {
  color: {
    $light: '#FF5F2E',
    $light20: 'rgba(255, 95, 46, 0.2)',
    $white: '#ffffff',
    $gray: '#C2C2CC',
    $transparent: 'transparent'
  },
  size: {
    $large: '100%',
    $normal: '1.4rem',
    $middle: '2.35rem',
    $small: '1.2rem',
    $h4: '.38rem',
    $h5: '.48rem'
  },
  type: {

    // default: {
    //   backgroundColor:
    // }
  }
};
export default {
  name: 'IButton',

  props: {
    heatBeat: [Boolean, Number],
    text: {
      type: String,
      default: 'Button'
    },
    disabled: Boolean,
    disabledClick: Boolean,
    type: {
      type: String,
      default: 'normal'
    },
    size: {
      type: String,
      default: 'normal'
    },
    height: {
      type: String,
      default: '4'
    },
    bg: String
  },

  computed: {
    style() {
      const option = {};
      const { color, size } = btnStyleMap;
      option.color = color.$white;
      option.backgroundColor = color.$light;
      option.width = size[`$${this.size}`] || '1.4rem';
      option.height = size[`$h${this.height}`] || '.4rem';
      const height4 = this.height === '4';
      option.borderRadius = height4 ? '.24rem' : '.25rem';

      // option.fontSize = height4 ? '.16rem' : '.18rem'
      option.fontSize = '.16rem';
      option.borderColor = color.$light;
      if (this.bg) {
        option.backgroundColor = this.bg;
        option.borderColor = this.bg;
      }
      if (this.type === 'shell') {
        option.backgroundColor = color.$transparent;
        option.borderColor = this.bg || color.$light;
        option.color = this.bg ? this.bg : color.$light;
      }
      return option;
    }
  },

  data() {
    return {};
  },
  methods: {
    clickHandle() {
      this.$emit('i-click');
    }
  }
};
</script>

<style scoped lang="stylus">
  .i_btn {
    border-width 1px
    border-style solid
    overflow hidden
    font-weight 500

    &.heat_beat {
      animation: heatBeat 1s infinite;
    }

    &.disabled_btn {
      opacity .2
    }

    @keyframes heatBeat {
      0% {
        transform: scale(.8); /*开始为原始大小*/
      }
      25% {
        transform: scale(1.2); /*放大1.1倍*/
      }
      66% {
        transform: scale(.8);
      }
    }
  }
</style>
